import React from 'react';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Textarea } from '@/components/ui/textarea';
import { RadioGroup, RadioGroupItem } from '@/components/ui/radio-group';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';
import { AdminTenantFormData, INDUSTRY_OPTIONS } from './types';

interface Props {
  data: AdminTenantFormData;
  updateData: (updates: Partial<AdminTenantFormData>) => void;
}

const StepClientDetails: React.FC<Props> = ({ data, updateData }) => {
  return (
    <div className="space-y-4">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div className="space-y-2">
          <Label htmlFor="businessName">
            Business Name <span className="text-destructive">*</span>
          </Label>
          <Input
            id="businessName"
            value={data.businessName}
            onChange={(e) => updateData({ businessName: e.target.value })}
            placeholder="Acme Accounting Ltd"
          />
        </div>

        <div className="space-y-2">
          <Label htmlFor="contactName">
            Contact Name <span className="text-destructive">*</span>
          </Label>
          <Input
            id="contactName"
            value={data.contactName}
            onChange={(e) => updateData({ contactName: e.target.value })}
            placeholder="John Smith"
          />
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div className="space-y-2">
          <Label htmlFor="email">
            Email <span className="text-destructive">*</span>
          </Label>
          <Input
            id="email"
            type="email"
            value={data.email}
            onChange={(e) => updateData({ email: e.target.value })}
            placeholder="client@example.com"
          />
        </div>

        <div className="space-y-2">
          <Label htmlFor="phone">Phone</Label>
          <Input
            id="phone"
            type="tel"
            value={data.phone}
            onChange={(e) => updateData({ phone: e.target.value })}
            placeholder="+64 21 123 4567"
          />
        </div>
      </div>

      <div className="space-y-2">
        <Label htmlFor="industry">
          Industry <span className="text-destructive">*</span>
        </Label>
        <Select value={data.industry} onValueChange={(value) => updateData({ industry: value })}>
          <SelectTrigger>
            <SelectValue placeholder="Select industry" />
          </SelectTrigger>
          <SelectContent>
            {INDUSTRY_OPTIONS.map((option) => (
              <SelectItem key={option.value} value={option.value}>
                {option.label}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      </div>

      <div className="space-y-2">
        <Label>Package Type</Label>
        <RadioGroup
          value={data.packageType}
          onValueChange={(value: 'starter' | 'professional') => updateData({ packageType: value })}
          className="flex gap-4"
        >
          <div className="flex items-center space-x-2">
            <RadioGroupItem value="starter" id="starter" />
            <Label htmlFor="starter" className="font-normal cursor-pointer">
              Starter
            </Label>
          </div>
          <div className="flex items-center space-x-2">
            <RadioGroupItem value="professional" id="professional" />
            <Label htmlFor="professional" className="font-normal cursor-pointer">
              Professional
            </Label>
          </div>
        </RadioGroup>
        <p className="text-xs text-muted-foreground">
          This will be marked as complimentary (no payment required)
        </p>
      </div>

      <div className="space-y-2">
        <Label htmlFor="useCase">
          Use Case <span className="text-destructive">*</span>
        </Label>
        <Textarea
          id="useCase"
          value={data.useCase}
          onChange={(e) => updateData({ useCase: e.target.value })}
          placeholder="Describe how the client plans to use their AI assistant..."
          rows={3}
        />
      </div>
    </div>
  );
};

export default StepClientDetails;
